import { forEach, mapKeys, cloneDeep } from 'lodash';
import { queryPersistence } from '@kc/gbiz-base/lib/QueryPersistence';
import * as services from './service';
import { PREFIX } from '../common/constants';
import { addSpmIntoQuery } from '../common/tools';
import storage from '../common/storage';
import { getAnonymousID } from './tools';

export const namespace = `${PREFIX}_header`;

const delayOffset = 0;

const initialValue = {
  otcLanguageList: null,
  levelInfo: {},
  assetDetail: {},
  langList: [],
  langListMap: {},
  currencyList: [],
  prices: {},
  siteList: [],
  feeDiscountConfig: {
    discountRate: 100,
    isGlobalDeductionEnabled: false,
  },
  userKcsDiscountStatus: false,
  navList: [],
  navMore: {},
  navActive: {},
  verifyStatus: undefined, // UNVERIFIED, VERIFIED, VERIFING
  showNewbieNav: false,
};

export default {
  namespace,
  state: initialValue,
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: {
    // 获取支持的语言列表
    *pullOtcLanguageList(_, { call, put }) {
      const { data } = yield call(services.getSupportPayTypes, { type: 'LANGUAGE' });
      yield put({
        type: 'update',
        payload: {
          otcLanguageList: data || [],
        },
      });
    },
    *logout({ payload: { to, spm } = {} }, { call }) {
      const { code } = yield call(services.logout);
      if (code === '200') {
        if (to) {
          window.location.href = addSpmIntoQuery(
            queryPersistence.formatUrlWithStore(`${window.location.origin}${to}`),
            spm,
          );
        } else {
          window.location.reload();
        }
      }
    },
    *pullUserLevel(_, { call, put }) {
      const { data } = yield call(services.getUserVipInfo);
      yield put({
        type: 'update',
        payload: {
          levelInfo: {
            ...data,
          },
        },
      });
      yield put({ type: 'getUserKcsDiscount' });
      yield put({ type: 'getFeeDeductionConfig' });
    },
    *pullKycStatus(_, { call, put }) {
      const { success, data } = yield call(services.getKysStatus);
      if (success && data) {
        const { verifyStatus = '' } = data || {};
        yield put({
          type: 'update',
          payload: {
            verifyStatus,
          },
        });
      }
    },
    *pullAssetDetail({ payload }, { put, call }) {
      const { balanceCurrency } = payload || {};
      const { success, data } = yield call(services.getAssetDetail2, {
        balanceCurrency: balanceCurrency || 'USDT',
      });
      if (success) {
        yield put({
          type: 'update',
          payload: {
            assetDetail: data,
          },
        });
      }
    },
    *pullLangList(_, { call, put }) {
      try {
        const { data } = yield call(services.getLangList);
        if (data) {
          const langListMap = {};
          forEach(data, (item) => {
            langListMap[item[0]] = {
              lang: item[0],
              langName: item[1],
            };
          });
          yield put({
            type: 'update',
            payload: {
              langList: data,
              langListMap,
            },
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    *pullRates({ payload }, { call, put }) {
      const { currencyListData } = payload;
      const currencyList = [];
      try {
        let data = currencyListData;
        // 如果有currencyListData， 那么将不再请求接口；
        // 避免项目和header 组件都会请求该数据
        if (!currencyListData) {
          const result = yield call(services.getRates);
          data = result.data;
        }
        if (data) {
          mapKeys(data, (value, key) => {
            if (key === 'CNY') {
              return key;
            }
            currencyList.push(key);
            return key;
          });
        }
      } catch (e) {
        console.log(e);
      }
      yield put({
        type: 'update',
        payload: {
          currencyList,
        },
      });
    },
    *pullPrices({ payload: { currency } }, { call, put }) {
      const { data } = yield call(services.getPrices, currency);
      yield put({
        type: 'update',
        payload: { prices: data || {} },
      });
    },
    *getManifestSiteList(_, { call, put }) {
      const start = Date.now();
      const { data, success } = yield call(services.getManifestSiteList);
      const end = Date.now();
      if (success && data && data.sites) {
        const { hostname } = window.location;
        const siteList = data.sites.map((i) => {
          if (hostname === i) return { name: i, delay: end - start - delayOffset, isCurrent: true };
          return { name: i };
        });
        yield put({ type: 'update', payload: { siteList } });
        // 从数组第1个开始测速
        yield put({ type: 'testDomainDelay' });
      }
    },
    *testDomainDelay({ payload = {} }, { call, put, select }) {
      const { index = 0 } = payload;
      const { siteList } = yield select((i) => i[namespace]);
      const list = cloneDeep(siteList);
      if (index >= list.length || list[index].delay) return;
      try {
        const start = Date.now();
        const { success } = yield call(
          services.getManifestSiteList,
          `https://${list[index].name}/_api`,
        );
        const end = Date.now();
        if (success) list[index].delay = end - start - delayOffset;
        else list[index].delay = 9999;
      } catch (e) {
        list[index].delay = 9999;
      } finally {
        yield put({ type: 'update', payload: { siteList: list } });
        // 遍历所有域名
        yield put({ type: 'testDomainDelay', payload: { index: index + 1 } });
      }
    },
    *getUserKcsDiscount(action, { put, call }) {
      const { data } = yield call(services.checkIsKcsDiscountOn);
      yield put({
        type: 'update',
        payload: {
          userKcsDiscountStatus: (data || {}).isDeductionEnabled || false,
        },
      });
    },
    *getFeeDeductionConfig(action, { put, call }) {
      const { data } = yield call(services.getFeeDeductionConfig);
      yield put({
        type: 'update',
        payload: {
          feeDiscountConfig: data,
        },
      });
    },
    *pullNavigationList({ payload }, { put, call }) {
      const navs = storage.getItem('kucoinv2_header_navs');
      if (navs) {
        yield put({
          type: 'update',
          payload: JSON.parse(navs),
        });
      }
      const { items } = yield call(services.getNavigation, payload);
      const navMore = items.find((i) => i.type === 99) || {};
      const navActive = items.find((i) => i.type === 98) || {};
      const list = items.filter((i) => i.type !== 99 && i.type !== 98);
      yield put({
        type: 'update',
        payload: {
          navMore,
          navList: list,
          navActive,
        },
      });
      storage.setItem(
        'kucoinv2_header_navs',
        JSON.stringify({
          navMore,
          navList: list,
          navActive,
        }),
      );
    },
    *pullNewbieNavItem(action, { put, call }) {
      const showNewbieNav = storage.getItem('kucoinv2_header_navs_showNewbieNav');
      // 有值就直接使用缓存
      if (showNewbieNav) {
        yield put({
          type: 'update',
          payload: {
            showNewbieNav: showNewbieNav === 'true',
          },
        });
      }
      const { data } = yield call(services.getNewbieEntry, {
        'X-SENSORS-ID': getAnonymousID(),
      });
      yield put({
        type: 'update',
        payload: {
          showNewbieNav: data?.markAsNovice,
        },
      });
      storage.setItem('kucoinv2_header_navs_showNewbieNav', JSON.stringify(data?.markAsNovice));
    },
  },
};
